import * as React from "react";
// sidebar-dialog
import { IContainer, IProps } from "./SidebarDialog.d";
import * as s from "./SidebarDialog.styles";
// material-ui
import { Dialog } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

class SidebarDialogCmpt extends React.PureComponent<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { isChromeExtension, classes, ...dialogProps } = this.props;
    const { backdrop, ...otherClasses } = classes;

    const width = isChromeExtension ? 300 : "100%";

    return (
      <Dialog
        {...dialogProps}
        classes={{
          ...otherClasses,
          paper: this.props.classes.paper,
        }}
        BackdropProps={{
          classes: { root: backdrop },
          style: { width },
        }}
        TransitionProps={
          {
            tabIndex: "none",
          } as any /* this fixes a very bad interplay between GCal and the extension */
        }
        style={{ ...s.style, ...this.props.style, width }}
      >
        {this.props.children}
      </Dialog>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const SidebarDialog = withStyles(s.styles)(
  SidebarDialogCmpt,
) as React.ComponentClass<IContainer>;
